import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { 
  Box,
  Button,
  MobileStepper,
  Typography,
  Fade,
} from '@mui/material';
import { Puc } from '../models/puc';
import CabinetRenderer from './cabinet-renderer';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

interface PucTemplateSelectorProps {
  pucTemplates: Array<Puc>,
  onPucSelected(selectedPuc: Puc): void
}

function PucTemplateSelector({ pucTemplates, onPucSelected }: PucTemplateSelectorProps) {
  const theme = useTheme();
  const [pucs, setPucs] = useState<Array<Puc>>([]);
  const [activeStep, setActiveStep] = useState<number>(0);
  const [maxSteps, setMaxSteps] = useState<number>(3);
  const [hardwareChanged, setHardwareChanged] = useState<number>(0);
  const [showRenderer, setShowRenderer] = useState<boolean>(true);

  useEffect(() => {
    if (pucTemplates.length === 0) {
      return;
    }
    const tempPucs = [];
    for (const puc of pucTemplates) {
      tempPucs.push(puc);
    }
    
    setMaxSteps(tempPucs.length);
    setPucs(tempPucs);
    setHardwareChanged(hardwareChanged+1);
    onPucSelected(tempPucs[activeStep]);
  }, [pucTemplates]);
  
  const handleNext = () => {
    let tempStep = activeStep;
    if (tempStep === maxSteps - 1) {
      tempStep = 0;
    } else {
      tempStep += 1;
    }
    setActiveStep(tempStep);
    onPucSelected(pucs[tempStep]);
    setShowRenderer(false);
    setTimeout(() => {
      setHardwareChanged(hardwareChanged + 1);
      setShowRenderer(true);
    }, 100);
  };
  const handleBack = () => {
    let tempStep = activeStep;
    if (tempStep === 0) {
      tempStep = maxSteps - 1;
    } else {
      tempStep -= 1;
    }
    setActiveStep(tempStep);
    onPucSelected(pucs[tempStep]);
    setShowRenderer(false);
    setTimeout(() => {
      setHardwareChanged(hardwareChanged + 1);
      setShowRenderer(true);
    }, 150);
  };
  
  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
      {pucs.length > 0 ?
        <Box sx={{
          border: 1,
          marginTop: '5px'
        }}>
          <Fade in={showRenderer}>
            <div>
              <Typography align='center' variant='h5'>{pucs[activeStep].serial}</Typography>
              <CabinetRenderer
                pucs={[pucs[activeStep]]}
                canvasWidth={676}
                canvasHeight={440}
                hardwareChanged={hardwareChanged}
                enableInput={false} />
            </div>
          </Fade>
          <MobileStepper
            variant="dots"
            steps={maxSteps}
            position="static"
            activeStep={activeStep}
            nextButton={
            <Button
              size="small"
              onClick={handleNext}
              disabled={maxSteps === 1}>
              {theme.direction === "rtl" ? (
                  <KeyboardArrowLeft />
              ) : (
                  <KeyboardArrowRight />
              )}
            </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={handleBack}
                disabled={maxSteps === 1}>
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
              </Button>
            } />
        </Box>
      :
        <div>
          <Typography align='center' style={{ marginTop: '20px' }}>NO PUC TEMPLATES FOUND</Typography>
          <Typography align='center'>Each template in the Puc Tool Template Store needs its own cabinet with a single PUC, tagged with puc_tool_template_full or puc_tool_template_addon</Typography>
        </div>
      }
    </div>
  );
}

export default PucTemplateSelector;
